import { render, staticRenderFns } from "./AlbumCreateModal.vue?vue&type=template&id=5ef425c8&scoped=true"
import script from "./AlbumCreateModal.vue?vue&type=script&lang=ts"
export * from "./AlbumCreateModal.vue?vue&type=script&lang=ts"
import style0 from "./AlbumCreateModal.vue?vue&type=style&index=0&id=5ef425c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef425c8",
  null
  
)

export default component.exports